module.exports = __webpack_public_path__ + "img/loading.2c338b00.gif";